import * as React from "react"
import {IconSeeker} from "@ui-seeker/core";
import {Box, Link} from "@mui/material";


export default function scopeColumn() {
    return [{
        name: 'digitalShelfScope', label: 'Digital Shelf Scope',
        options: {
            display: 'excluded',
            customBodyRowRender: (value) => !!value ? 'Yes' : 'No'
        }
    },{
        name: 'digitalShelfScope', label: 'Digital Shelf Scope',
        options: {
            filter: false,
            customBodyRowRenderLite: (value) => {
                const icon = !!value ? 'check' : 'xmark'
                const iconColor = !!value ?  "success.main" : "error.main"

                return <Box display={"flex"} justifyContent={"center"}>
                    <IconSeeker icon={icon} sx={{ color: iconColor }} />
                </Box>
            }
        }
    }]
}